module.exports = __webpack_public_path__ + "static/img/anos_40.e853f42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/linha-tempo/anos_40.png
// module id = Is5a
// module chunks = 0